import { roundRating } from '../../../../../domain';
import starImg from '../../../components/atomic/icons/star/star.png';
import './RatingStars.css';

/** Star positions from Figma Group 141:8991 (stars 1–5). */
const STARS = [
  { id: 1, top: 1226.2479, left: 269 },
  { id: 2, top: 1221.477, left: 350.1782 },
  { id: 3, top: 1221.477, left: 447.4726 },
  { id: 4, top: 1221.477, left: 544.7661 },
  { id: 5, top: 1221.477, left: 642.0612 },
] as const;

const STAR_WIDTH = 145.7608;
const STAR_HEIGHT = 140.7695;

/** Целое число звёзд на шкале 0–5 (3.5 → 3). */
function visibleStarCount(rating: number): number {
  return Math.min(5, Math.max(0, Math.floor(roundRating(rating))));
}

type RatingStarsProps = {
  rating?: number | null;
};

/** Rating stars row (Figma 141:8991). */
export function RatingStars({ rating }: RatingStarsProps) {
  const starCount =
    rating != null && Number.isFinite(rating) ? visibleStarCount(rating) : 0;

  return (
    <>
      {STARS.slice(0, starCount).map((star) => (
        <img
          key={star.id}
          className="rating-stars__star"
          src={starImg}
          alt=""
          draggable={false}
          aria-hidden
          style={{
            top: star.top,
            left: star.left,
            width: STAR_WIDTH,
            height: STAR_HEIGHT,
            zIndex: star.id,
          }}
        />
      ))}
    </>
  );
}
